import { useState } from "react";
import { ScreenTab, ThemeScreenProps } from "../types";
import CategoriesScreen from "./CategoriesScreen";
import ItemDetailScreen from "./ItemDetailScreen";
import CartScreen from "./CartScreen";
import {
  PreviewPanel,
  PreviewLabel,
  ScreenToggle,
  ToggleBtn,
  PhoneFrame,
  PhoneNotch,
  Notch,
  PhoneScreen,
  HintText,
} from "../styles";

function KioskPreview({ colors }: ThemeScreenProps) {
  const [screen, setScreen] = useState<ScreenTab>("categories");

  return (
    <PreviewPanel>
      <PreviewLabel>Live Preview</PreviewLabel>

      <ScreenToggle>
        <ToggleBtn $active={screen === "categories"} onClick={() => setScreen("categories")}>
          Categories
        </ToggleBtn>
        <ToggleBtn $active={screen === "detail"} onClick={() => setScreen("detail")}>
          Item Detail
        </ToggleBtn>
        <ToggleBtn $active={screen === "cart"} onClick={() => setScreen("cart")}>
          Cart
        </ToggleBtn>
      </ScreenToggle>

      <PhoneFrame>
        <PhoneNotch>
          <Notch />
        </PhoneNotch>
        <PhoneScreen>
          {screen === "categories" ? (
            <CategoriesScreen colors={colors} />
          ) : screen === "detail" ? (
            <ItemDetailScreen colors={colors} />
          ) : (
            <CartScreen colors={colors} />
          )}
        </PhoneScreen>
      </PhoneFrame>

      <HintText>Colors update in real-time</HintText>
    </PreviewPanel>
  );
}

export default KioskPreview;
